<template>
  <a-gradient-border class="homepage-key-statistics-additional-block__wrapper">
    <div class="homepage-key-statistics-additional-block__container">
      <div class="homepage-key-statistics-additional-block__body">
        <div
          class="homepage-key-statistics-additional-block__title text-tiny uppercase"
        >
          {{ item.title }}
        </div>
        <a-icon
          :original="true"
          :no-hover="true"
          :icon="$options.consts.ICON.ARROW_BLUE_TOP_RIGHT"
          :width="36"
          :height="25"
          class="homepage-key-statistics-additional-block__arrow"
        />
        <div class="homepage-key-statistics-additional-block__percentage">
          +{{ item.percentage }}%
        </div>
        <div class="homepage-key-statistics-additional-block__description">
          {{ item.description }}
        </div>
        <div class="homepage-key-statistics-additional-block__chart-wrapper">
          <a-icon
            :original="true"
            :no-hover="true"
            :icon="item.icon"
            width="auto"
            :height="item.iconHeight"
            class="homepage-key-statistics-additional-block__chart"
          />
          <span
            class="homepage-key-statistics-additional-block__chart-percentage"
          >
            +{{ item.percentage }}%
          </span>
        </div>
      </div>

      <div class="homepage-key-statistics-additional-block__footer">
        <p class="homepage-key-statistics-additional-block__footer-text">
          {{ item.footerText }}
        </p>
      </div>
    </div>
  </a-gradient-border>
</template>

<script>
import AIcon, { ICON } from 'shared/AIcon/index.vue'
import AGradientBorder from 'shared/AGradientBorder/index.vue'
import { PROP_TYPES, propValidator } from '@fmpedia/validators'

export default {
  name: 'HomepageKeyStatisticsAdditionalBlock',
  components: { AGradientBorder, AIcon },
  props: {
    item: propValidator([PROP_TYPES.OBJECT])
  },
  consts: {
    ICON
  }
}
</script>

<style lang="scss" scoped>
.homepage-key-statistics-additional-block__wrapper {
  padding: 2px;
  border-radius: 16px;
  max-width: 400px;

  $margin: (
    $above-desktop-xl: 64px 32px 0 32px,
    $tablet: 32px 0 0,
    $mobile: 24px 0 0
  );

  $width: (
    $above-desktop-xl: 400px,
    $mobile: 100%
  );

  @include setStyleByBreakpoint('width', $width);
  @include setStyleByBreakpoint('margin', $margin);
}

.homepage-key-statistics-additional-block__container {
  overflow: hidden;
}

.homepage-key-statistics-additional-block__body {
  background: $c--gray-dark;
  display: grid;
  grid-template-areas:
    'title icon'
    'percentage percentage'
    'description description'
    'chart chart';
  grid-row-gap: 20px;
  grid-template-columns: 1fr 36px;

  $padding: (
    $above-desktop-xl: 40px 30px 0px
  );

  @include setStyleByBreakpoint('padding', $padding);
}

.homepage-key-statistics-additional-block__title {
  font-weight: 700;
  grid-area: title;
}

.homepage-key-statistics-additional-block__arrow {
  grid-area: icon;
}

.homepage-key-statistics-additional-block__percentage {
  grid-area: percentage;
  font-weight: 600;

  $font-size: (
    $above-desktop-xl: 48px,
    $mobile: 36px
  );

  $line-height: (
    $above-desktop-xl: 60px,
    $mobile: 36px
  );

  @include setStyleByBreakpoint('line-height', $line-height);
  @include setStyleByBreakpoint('font-size', $font-size);
}

.homepage-key-statistics-additional-block__description {
  grid-area: description;
  font-size: 18px;
  font-weight: 500;
}

.homepage-key-statistics-additional-block__chart-wrapper {
  grid-area: chart;
  position: relative;
  height: 200px;
  display: flex;
  overflow: hidden;
}

.homepage-key-statistics-additional-block__chart {
  display: flex;
  justify-content: flex-end;
  width: 100%;
}

.homepage-key-statistics-additional-block__chart-percentage {
  position: absolute;
  bottom: 42px;
  right: 10px;
  font-weight: 600;

  $font-size: (
    $above-desktop-xl: 30px,
    $mobile: 24px
  );

  $line-height: (
    $above-desktop-xl: 38px,
    $mobile: 32px
  );

  @include setStyleByBreakpoint('line-height', $line-height);
  @include setStyleByBreakpoint('font-size', $font-size);
}

.homepage-key-statistics-additional-block__footer {
  height: 100px;
  background: $c--coal-black;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  border-top: 2px solid #515256;
  line-height: 24px;

  @include mobile {
    padding: 0 30px;
  }
}

.homepage-key-statistics-additional-block__footer-text {
  color: $c--blue-secondary;
  font-weight: 400;

  $font-size: (
    $above-desktop-xl: 17px,
    $mobile: 16px
  );

  @include setStyleByBreakpoint('font-size', $font-size);
}
</style>
